import Base from "./Base";
import axios from "./axios_c";
import Bom from "@system/config/bom";
import Helper from "src/support/Helper";

class BOMRematchAPICall extends Base {
    fetchStaticColumns = async () => {
        let res = {};
        await this.axiosCall(Bom.BOM_REMATCH_STATIC_COLUMN, {}, 'GET').then((resHer) => {
            res = resHer.data;
        });
        return res;
    };
    fetchSavedColumnsPreferenceByBomID = async (params) => {
        let res = {};
        await this.axiosCall(Bom.BOM_SAVED_REMATCH_COLUMN_PREFERENCE, params, 'GET').then((resHer) => {
            res = resHer.data.data;
        }).catch(e => {
            window.location.href = Bom.getBomRouteURL();
        });
        return res;
    };
    fetchSavedColumnsDataByBomID = async (params) => {
        let res = {};
        await this.axiosCall(Bom.BOM_REMATCH_COLUMN_DATA, params, 'GET').then((resHer) => {
            res = resHer.data.data;
        }).catch(e => {
            window.location.href = Bom.getBomRouteURL();
        });
        return res;
    };
    saveColumnsPreferenceByBomID = async (params) => {
        let res = {};
        await this.axiosCall(Bom.BOM_SAVE_REMATCH_COLUMN_PREFERENCE, params, 'POST', true).then((resHer) => {
            res = resHer.data.data;
        });
        return res;
    };
    axiosCall = async (url, data = {}, method = 'post', skipParams = false) => {
        let config = {
            method: method,
            url: url,
            headers: Helper.getCommonHeader(method),
            data: data
        };
        if (skipParams === false && (config.method !== 'post' && config.method !== 'POST')) {
            config.params = data;
        }
        return axios(config);
    };
}

export default BOMRematchAPICall;